var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5V4C7 2.34315 8.34315 1 10 1H12C13.6569 1 15 2.34315 15 4V5M1 12H21M7 10.5V13.5M15 10.5V13.5M5 21H17C19.2091 21 21 19.2091 21 17V9C21 6.79086 19.2091 5 17 5H5C2.79086 5 1 6.79086 1 9V17C1 19.2091 2.79086 21 5 21Z",
    stroke: "#18417E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.2b0065ce5e45aa6f6e1bc04be5a0b967.svg";
export { ForwardRef as ReactComponent };